/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Benefits_Item6Inputs */

const ja_playdata_home_benefits_item6 = /** @type {(inputs: Playdata_Home_Benefits_Item6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントごとの累計視聴時間を知りたい`)
};

const en_playdata_home_benefits_item6 = /** @type {(inputs: Playdata_Home_Benefits_Item6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to find the total viewing time for each event`)
};

/**
* | output |
* | --- |
* | "I want to find the total viewing time for each event" |
*
* @param {Playdata_Home_Benefits_Item6Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_benefits_item6 = /** @type {((inputs?: Playdata_Home_Benefits_Item6Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Benefits_Item6Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_benefits_item6(inputs)
	return en_playdata_home_benefits_item6(inputs)
});